/**
 * Simple hash function for comparing objects
 * Uses JSON.stringify with sorted keys for consistent hashing
 */
export function createHash(obj: any): string {
  if (obj === null || obj === undefined) {
    return 'null';
  }
  
  // Sort object keys for consistent hashing
  const sortedObj = sortObjectKeys(obj);
  return JSON.stringify(sortedObj);
}

/**
 * Recursively sort object keys for consistent hashing
 */
function sortObjectKeys(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(item => sortObjectKeys(item));
  }
  
  if (obj !== null && typeof obj === 'object') {
    const sortedKeys = Object.keys(obj).sort();
    const sortedObj: any = {};
    
    for (const key of sortedKeys) {
      sortedObj[key] = sortObjectKeys(obj[key]);
    }
    
    return sortedObj;
  }
  
  return obj;
}

/**
 * Compare two objects by their hash
 */
export function hashesEqual(obj1: any, obj2: any): boolean {
  return createHash(obj1) === createHash(obj2);
}
